import { render, staticRenderFns } from "./FoodProductionOrders.vue?vue&type=template&id=6d44c64b&scoped=true"
import script from "./FoodProductionOrders.vue?vue&type=script&lang=js"
export * from "./FoodProductionOrders.vue?vue&type=script&lang=js"
import style0 from "./FoodProductionOrders.vue?vue&type=style&index=0&id=6d44c64b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d44c64b",
  null
  
)

export default component.exports